/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 2dMe7XWUq916KsPnra5vYj
// Component: jfBLn3a3U6

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  renderPlasmicSlot,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_end_user_management.css"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/projectcss
import sty from "./PlasmicActivityRow.module.css"; // plasmic-import: jfBLn3a3U6/css

import UserSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__UserSvg"; // plasmic-import: ejczgMIkT/icon

createPlasmicElementProxy;

export type PlasmicActivityRow__VariantMembers = {
  withoutBorder: "withoutBorder";
};
export type PlasmicActivityRow__VariantsArgs = {
  withoutBorder?: SingleBooleanChoiceArg<"withoutBorder">;
};
type VariantPropType = keyof PlasmicActivityRow__VariantsArgs;
export const PlasmicActivityRow__VariantProps = new Array<VariantPropType>(
  "withoutBorder"
);

export type PlasmicActivityRow__ArgsType = {
  user?: React.ReactNode;
  status?: React.ReactNode;
  updatedAt?: React.ReactNode;
};
type ArgPropType = keyof PlasmicActivityRow__ArgsType;
export const PlasmicActivityRow__ArgProps = new Array<ArgPropType>(
  "user",
  "status",
  "updatedAt"
);

export type PlasmicActivityRow__OverridesType = {
  root?: Flex__<"div">;
  svg?: Flex__<"svg">;
  columns?: Flex__<"div">;
};

export interface DefaultActivityRowProps {
  user?: React.ReactNode;
  status?: React.ReactNode;
  updatedAt?: React.ReactNode;
  withoutBorder?: SingleBooleanChoiceArg<"withoutBorder">;
  className?: string;
}

const $$ = {};

function PlasmicActivityRow__RenderFunc(props: {
  variants: PlasmicActivityRow__VariantsArgs;
  args: PlasmicActivityRow__ArgsType;
  overrides: PlasmicActivityRow__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "withoutBorder",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.withoutBorder,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_2dMe7XWUq916KsPnra5vYj",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootwithoutBorder]: hasVariant(
            $state,
            "withoutBorder",
            "withoutBorder"
          ),
        }
      )}
    >
      <UserSvgIcon
        data-plasmic-name={"svg"}
        data-plasmic-override={overrides.svg}
        className={classNames("all", sty.svg)}
        role={"img"}
      />

      <div
        data-plasmic-name={"columns"}
        data-plasmic-override={overrides.columns}
        className={classNames("all", sty.columns)}
      >
        <div
          className={classNames("all", sty.column__mF7Q8, {
            [sty.columnwithoutBorder__mF7Q8YPo7C]: hasVariant(
              $state,
              "withoutBorder",
              "withoutBorder"
            ),
          })}
        >
          <div className={classNames("all", sty.freeBox__eySi)}>
            {renderPlasmicSlot({
              defaultContents: "user@plasmic.app",
              value: args.user,
              className: classNames(sty.slotTargetUser),
            })}
          </div>
          <div className={classNames("all", sty.freeBox__jnPaY)}>
            {renderPlasmicSlot({
              defaultContents: "Logged in",
              value: args.status,
              className: classNames(sty.slotTargetStatus),
            })}
          </div>
        </div>
        <div className={classNames("all", sty.column__h1Htb)}>
          <div className={classNames("all", sty.freeBox__iC1)}>
            {renderPlasmicSlot({
              defaultContents: "5m ago",
              value: args.updatedAt,
              className: classNames(sty.slotTargetUpdatedAt),
            })}
          </div>
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "svg", "columns"],
  svg: ["svg"],
  columns: ["columns"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  svg: "svg";
  columns: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicActivityRow__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicActivityRow__VariantsArgs;
    args?: PlasmicActivityRow__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicActivityRow__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicActivityRow__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicActivityRow__ArgProps,
          internalVariantPropNames: PlasmicActivityRow__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicActivityRow__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicActivityRow";
  } else {
    func.displayName = `PlasmicActivityRow.${nodeName}`;
  }
  return func;
}

export const PlasmicActivityRow = Object.assign(
  // Top-level PlasmicActivityRow renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    svg: makeNodeComponent("svg"),
    columns: makeNodeComponent("columns"),

    // Metadata about props expected for PlasmicActivityRow
    internalVariantProps: PlasmicActivityRow__VariantProps,
    internalArgProps: PlasmicActivityRow__ArgProps,
  }
);

export default PlasmicActivityRow;
/* prettier-ignore-end */
